export enum WORKER_FLAGS {
  enableBiggerWaiterImage = "enable-bigger-waiter-image",
} 